/**
 * [임시/throwaway] Quiz Set API (LC) — AIQ 테스트 세트 조회용.
 * admin의 quizSet 클라이언트를 미러링. quizId는 BigInt이므로 detail은 text로 받아 정규화한다.
 */
import { apiClient } from './client'

export interface ResolvedQuiz {
  quizId: string
  title?: string | null
  type?: string | null
  difficultyLevel?: number | null
  thumbnailUrl?: string | null
}

export interface QuizSetSummary {
  id: number
  name: string
  levelType?: string | null
  levelValue?: string | null
  /** 학기로 나뉜 레벨 테스트 세트만 1·2. 서버가 null이면 필드를 생략한다. */
  semester?: number | null
  isActive: boolean
  sortOrder: number
  memberCount: number
  createdAt: string
  updatedAt: string
}

export interface QuizGroupItem {
  sequenceOrder: number
  type: string // 'Q' | 'QQS'
  quiz: ResolvedQuiz
}

export interface QuizGroupDetail {
  id: number
  name: string
  description?: string | null
  isActive: boolean
  sortOrder: number
  items: QuizGroupItem[]
  createdAt: string
  updatedAt: string
}

export interface QuizSetMember {
  sequenceOrder: number
  kind: 'quiz' | 'group'
  quiz?: ResolvedQuiz | null
  group?: QuizGroupDetail | null
}

export interface QuizSetDetail {
  id: number
  name: string
  description?: string | null
  levelType?: string | null
  levelValue?: string | null
  /** 학기로 나뉜 레벨 테스트 세트만 1·2. 서버가 null이면 필드를 생략한다. */
  semester?: number | null
  isActive: boolean
  sortOrder: number
  members: QuizSetMember[]
  createdAt: string
  updatedAt: string
}

interface Envelope<T> {
  data: T | null
}

export const getQuizSets = async (params?: {
  levelType?: string
  levelValue?: string
}): Promise<QuizSetSummary[]> => {
  const response = await apiClient.get<Envelope<QuizSetSummary[]>>('/quiz-sets', { params })
  return response.data.data ?? []
}

export const getQuizSet = async (id: number): Promise<QuizSetDetail> => {
  const response = await apiClient.get<string>(`/quiz-sets/${id}`, { responseType: 'text' })
  const normalized = response.data.replace(/"quizId"\s*:\s*(\d+)/g, '"quizId":"$1"')
  const parsed = JSON.parse(normalized) as Envelope<QuizSetDetail>
  if (!parsed.data) throw new Error('Invalid quiz set response')
  return parsed.data
}
